<template>
  <div v-if="user" class="px-5 py-4 border-b border-white/10">
    <div class="flex items-center gap-3">
      <div class="w-9 h-9 rounded-full bg-primary-container flex items-center justify-center text-white text-sm font-bold">
        {{ initials }}
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm font-semibold text-on-surface truncate">{{ user.displayName }}</p>
        <p class="text-[11px] text-on-surface-variant truncate">{{ user.email }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import useUser from '@/composables/useUser';

const { user } = useUser();

const initials = computed(() => {
  const name = user.value?.displayName || '';
  return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';
});
</script>
